import React from 'react';
import { FormikProps, connect as formikConnect } from 'formik';

import debounce from 'lodash/debounce';

type Props = {
  name: string,
  debounce: ?number,
  formik: FormikProps,
};

class Persist extends React.Component<Props> {
  static defaultProps = { debounce: 0 };

  saveForm = debounce(data => {
    window.sessionStorage.setItem(this.props.name, JSON.stringify(data));
  }, this.props.debounce);

  componentDidMount() {
    const { name, formik } = this.props;

    const initialState = window.sessionStorage.getItem(name);

    if (initialState) formik.setValues(JSON.parse(initialState));
  }

  componentDidUpdate() {
    const {
      name,
      formik: { values },
    } = this.props;

    window.sessionStorage.setItem(name, JSON.stringify(values));
  }

  render() {
    return null;
  }
}

export default formikConnect(Persist);



// WEBPACK FOOTER //
// ./src/screens/Flights/PassengerDetails/FormikPersist.js